import { render, staticRenderFns } from "./ME23Collection.vue?vue&type=template&id=01eae90b&scoped=true&"
import script from "./ME23Collection.vue?vue&type=script&lang=js&"
export * from "./ME23Collection.vue?vue&type=script&lang=js&"
import style0 from "./ME23Collection.vue?vue&type=style&index=0&id=01eae90b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eae90b",
  null
  
)

export default component.exports